export const karolinaKasprzak = {
    'mydrId': 'karolinakasprzak',
    'firstName': 'Karolina',
    'lastName': 'Kasprzak',
    'profession': 'Psychotraumatolog, psychoterapeuta Gestalt w trakcie szkolenia',
    'avatar': 'karolina-kasprzak.webp',
    'slug': 'psycholog-psychoterapeuta-karolina-kasprzak',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'adult'],
        // ['group', 'developmentGroupGestalt']
    ]
}